import { defineStore } from "pinia";

declare global {
    interface Window {
        dataLayer?: Record<string, any>[];
    }
}

export const useAnalyticsStore = defineStore("analytics", () => {
    const firedOnce = new Set<string>();

    function fire(event: string, payload: Record<string, any>) {
        console.groupCollapsed(`📊 Analytics Event: ${event}`);
        console.log(payload);
        console.groupEnd();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event,
            ...payload,
        });
    }

    function fireOnce(
        event: string,
        payload: Record<string, any>,
        key = event,
    ) {
        if (firedOnce.has(key)) return;

        firedOnce.add(key);
        fire(event, payload);
    }

    return { fire, fireOnce };
});
